 import React, { useState, useEffect } from 'react'
 import { useForm } from 'react-hook-form'
 import { useHistory, useParams } from 'react-router-dom'
import { BsFillCameraVideoFill, BsImages } from 'react-icons/bs'
import { MdAddAPhoto } from 'react-icons/md'
import { GiBoomerang, GiPerspectiveDiceThree } from 'react-icons/gi'
import { HiOutlineShare } from 'react-icons/hi'
import Layout from '../../components/layouts/Layout'
import NewFormWizard from '../../components/formWizard/NewFormWizard'
import http from '../../config/BaseUrl'
import { LoadingSpinner } from '../../components/Loader/Loader'
import LocalStorage from '../../hook/LocalStorage';

const EventFeaturesEdit = () => {

    const history = useHistory();
    const { id } = useParams();

    const { user } = LocalStorage()

    const eventFeatureItem = history.location.state.eventFeature
    const [packageTypes, setPackageTypes] = useState(null)
    const [loading, setLoading] = useState(false)
    const { register, handleSubmit } = useForm({
        defaultValues: {
            still_photo: eventFeatureItem.still_photo[0].status,
            three_in_one: eventFeatureItem.three_in_one[0].status,
            video: eventFeatureItem.video[0].status,
            boomerang: eventFeatureItem.boomerang[0].status,
            sharing: eventFeatureItem.sharing[0].status,
            gallery: eventFeatureItem.gallery[0].status,
            data_capture: eventFeatureItem.data_capture[0].status,
        }
    });


    useEffect(() => {
        let mounted = true

        const loadPackageTypes = async () => {
            setLoading(true)

            try {
                const res = await http.get('/package-type')
                const data = Array.isArray(res?.data?.packageType) ? res.data.packageType : []
                let singleData = []
                let monthlyData = []
                let yearlyData = []
                let trialData = []
                data.forEach(item=>{
                    const packageItemValues = Array.isArray(item?.package_item_value) ? item.package_item_value : []
                    const filterByType = (type) => packageItemValues.filter(
                        filterItem => filterItem?.our_package?.package_type?.type === type
                    )

                    singleData = [...singleData, {item_name: item.item_name, itemData: filterByType("single")}]
                    monthlyData = [...monthlyData, {item_name: item.item_name, itemData: filterByType("monthly")}]
                    yearlyData = [...yearlyData, {item_name: item.item_name, itemData: filterByType("yearly")}]
                    trialData = [...trialData, {item_name: item.item_name, itemData: filterByType("trial")}]
                })
                
                const packageId = user?.membership?.package_id
                const packageType = user?.membership?.our_package?.package_type?.type

                let bindingItems = ["Data Capture"]
                let bindingsData
                if (packageType === 'trial') {
                    bindingsData = checkPackageBinding(bindingItems, trialData, packageId)
                }
                else if (packageType === 'monthly') {
                    bindingsData = checkPackageBinding(bindingItems, monthlyData, packageId)
                }
                else if(packageType === 'single'){
                    bindingsData = checkPackageBinding(bindingItems, singleData, packageId)
                }
                else{
                    bindingsData = checkPackageBinding(bindingItems, yearlyData, packageId)
                }

                let bindingObject = bindingsData.reduce(function(result, item) {
                    var key = Object.keys(item)[0];
                    result[key] = item[key];
                    return result;
                  }, {});

                if (mounted) {
                    setPackageTypes(bindingObject)
                }
            } catch (error) {
                if (mounted) {
                    setPackageTypes({ data_capture: 0 })
                }
            } finally {
                if (mounted) {
                    setLoading(false)
                }
            }
        }

        loadPackageTypes()

        return () => {
            mounted = false
        }
    }, [user?.membership?.our_package?.package_type?.type, user?.membership?.package_id])

    const checkPackageBinding = (bindingItems, packageData, packageId) => {
        let bindingsData = []
        bindingItems.forEach(item=>{
            let findData = packageData.find(data => data.item_name === item)
            let findPackage = packageId === null || packageId === undefined
                ? null
                : findData?.itemData?.find(dataItem => String(dataItem.our_package_id) === String(packageId))

            if (item === "Data Capture") {
                bindingsData.push({"data_capture": findPackage?.value === "true" || findPackage?.value === true ? 1 : 0})
            }
            
        })

        return bindingsData
    }


    const handelFeatureUpdate = async (data) => {
        setLoading(true)
        try {
            const res = await http.post(`/event/feature/update/${id}`, {...data, eventId:eventFeatureItem.event_id} )
            setLoading(false)

            if (res) {
                history.push(`/show/event/${eventFeatureItem.event_id}`, 'Information Updated.')
            }
        } catch (error) {
            // Keep the form available so the user can retry the update.
            setLoading(false)
        }
    }



    return (
        <Layout>
            <NewFormWizard />
            <form onSubmit={handleSubmit(handelFeatureUpdate)}>
                <section className="mt-5">
                    <div className="row justify-content-center">
                        <div className="col-md-10">
                            <div className="px-4 card" style={{ minHeight: '50vh' }}>
                                <div className="card-body">
                                    <div className="pt-5 select__photo--area">
                                        <div className="flex-wrap d-flex justify-content-center">
                                            <div className="photo__booth__area_checkbox">
                                                <label className="option_item">
                                                    <input type="checkbox" className="checkbox" checked   {...register("still_photo")} />
                                                    <div className="option_inner photo__booth">
                                                        <div className="tick-mark"></div>
                                                        <div className="icon">
                                                            <MdAddAPhoto size={25} color={'#fff'} />
                                                        </div>
                                                        <p className="mt-2 mb-0 text-white">Still Photo</p>
                                                    </div>
                                                </label>
                                            </div>
                                                     
                                            <div className="photo__booth__area_checkbox">
                                                <label className="option_item">
                                                    <input type="checkbox" className="checkbox"  {...register("three_in_one")} />
                                                    <div className="option_inner photo__booth">
                                                        <div className="tick-mark"></div>
                                                        <div className="icon">
                                                            <GiPerspectiveDiceThree size={25} color={'#fff'} />
                                                        </div>
                                                        <p className="mt-2 mb-0 text-white">3 In 1</p>
                                                    </div>
                                                </label>
                                            </div>

                                            <div className="photo__booth__area_checkbox">
                                                <label className="option_item">
                                                    <input type="checkbox" className="checkbox"  {...register("video")} />
                                                    <div className="option_inner photo__booth">
                                                        <div className="tick-mark"></div>
                                                        <div className="icon">
                                                            <BsFillCameraVideoFill size={25} color={'#fff'} />
                                                        </div>
                                                        <p className="mt-2 mb-0 text-white">Video</p>
                                                    </div>
                                                </label>
                                            </div>

                                            <div className="photo__booth__area_checkbox">
                                                <label className="option_item">
                                                    <input type="checkbox" className="checkbox"  {...register("boomerang")} />
                                                    <div className="option_inner photo__booth">
                                                        <div className="tick-mark"></div>
                                                        <div className="icon">
                                                            <GiBoomerang size={25} color={'#fff'} />
                                                        </div>
                                                        <p className="mt-2 mb-0 text-white">Boomerang</p>
                                                    </div>
                                                </label>
                                            </div>

                                            <div className="photo__booth__area_checkbox">
                                                <label className="option_item">
                                                    <input type="checkbox" className="checkbox"  {...register("gallery")} />
                                                    <div className="option_inner photo__booth">
                                                        <div className="tick-mark"></div>
                                                        <div className="icon">
                                                            <BsImages size={25} color={'#fff'} />
                                                        </div>
                                                        <p className="mt-2 mb-0 text-white">Gallery</p>
                                                    </div>
                                                </label>
                                            </div>

                                            <div className="photo__booth__area_checkbox">
                                                <label className="option_item">
                                                    <input type="checkbox" className="checkbox"  {...register("sharing")} />
                                                    <div className="option_inner photo__booth">
                                                        <div className="tick-mark"></div>
                                                        <div className="icon">
                                                            <HiOutlineShare size={25} color={'#fff'} />
                                                        </div>
                                                        <p className="mt-2 mb-0 text-white">Sharing</p>
                                                    </div>
                                                </label>
                                            </div>

                                            <div className="photo__booth__area_checkbox">
                                                <label className="option_item">
                                                    <input 
                                                        type="checkbox" 
                                                        className="checkbox"  
                                                        disabled={packageTypes && packageTypes.data_capture ? false : true}
                                                        {...register("data_capture")} />
                                                    <div 
                                                        className={`option_inner photo__booth ${packageTypes && packageTypes.data_capture ? '' : 'disable-item'}`}>
                                                        <div className="tick-mark"></div>
                                                        <div className="icon">
                                                            <GiBoomerang size={25} color={'#fff'} />
                                                        </div>
                                                        <p className="mt-2 mb-0 text-white">Data Capture</p>
                                                    </div>
                                                    {
                                                        packageTypes && 
                                                        packageTypes.data_capture ? 
                                                        "" 
                                                        : 
                                                        <div className="option_inner_popup"><p>Upgrade your package</p></div>
                                                    }
                                                </label>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="py-5 text-center border-top">
                                    <h4 className="text-primary display-4 event-form-title">Event Features</h4>
                                    <span className="text-secondary">Select the features you want active.</span>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="my-5 row justify-content-center">
                        <div className="col-md-10">
                            {!loading 
                            
                            ? <button type="submit" className="float-right px-5 btn btn-outline-primary radius-10" >Update</button>
                            : <button type="button" className="float-right px-5 btn btn-outline-primary radius-10 disabled" >
                                <LoadingSpinner className="spinner-grow-sm" />
                            </button>
                            }
                            
                        </div>
                    </div>

                </section>
            </form>
        </Layout>
    )
}

export default EventFeaturesEdit
